<template>
    <div>
        <v-card color="grey lighten-5 ma-0 pa-0" :loading="loading">
            <document-action-header
                :title="$t('Site.LinkedDocuments.Titles.LinkedDocuments')"
                @on-close-click="onCloseClick"
            >
                <template slot="actionTemplate">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" @click="add">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t("Add") }}</span>
                    </v-tooltip>
                </template>
            </document-action-header>

            <v-card-text class="overflow-y-auto pa-2 py-1 overflow-x-hidden" style="max-height: 250px">
                <v-row
                    justify="center"
                    align="center"
                    v-if="linkedDocumentList.length == 0 && !loading"
                >
                    <div class="text-center">
                        <a link @click="add">
                            {{ $t("Add") }}
                            <v-icon>mdi-plus</v-icon>
                        </a>
                    </div>
                </v-row>

                <template v-for="linkedDocument in linkedDocumentList">
                    <template>
                        <LinkedDocumentItem
                            :linkedDocument="linkedDocument"
                            :key="linkedDocument.id"
                            @on-edit-linked-document="onEdit"
                            @on-unlink-document="onRemove"
                            @on-display-linked-document="onDisplay"
                        />
                    </template>
                </template>
            </v-card-text>
        </v-card>
        <LinkDocumentModal
            :ref="modalKeyAdd"
            @on-linked-document-saved="onSaved"
        />
        <LinkedDocumentEditModal
            :ref="modalKeyEdit"
            @on-linked-document-edited="onSaved"
        ></LinkedDocumentEditModal>
        <LinkedDocumentDisplayModal :ref="displayModalKey" />
    </div>
</template>

<script>
import DocumentActionHeader from '@/components/search/results/list/item/actions/DocumentActionHeader';
import LinkedDocumentItem from '@/components/search/results/list/item/actions/link/LinkedDocumentItem';
import LinkDocumentModal from '@/components/search/results/list/item/actions/link/LinkDocumentModal';
import LinkedDocumentService from '@/services/LinkedDocumentService';
import LinkedDocument from '@/ecm/models/search/results/list/LinkedDocument';
import LinkedDocumentEditModal from './LinkedDocumentEditModal.vue';
import LinkedDocumentDisplayModal from './LinkedDocumentDisplayModal.vue';
import Utils from '@/ecm/common/Utils';
export default {
    name: 'LinkedDocumentsList',
    components: {
        DocumentActionHeader,
        LinkedDocumentItem,
        LinkDocumentModal,
        LinkedDocumentEditModal,
        LinkedDocumentDisplayModal,
    },
    props: {
        documentId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.loadData();
    },
    data() {
        return {
            linkedDocumentList: [],
            loading: false,
            modalKeyEdit: 'modalLinkDocumentAdd',
            modalKeyAdd: 'modalLinkDocumentEdit',
            displayModalKey: 'modalDisplayLinkedDocument',
        };
    },
    computed: {
        modalInstanceAdd() {
            return this.$refs[this.modalKeyAdd];
        },
        modalInstanceEdit() {
            return this.$refs[this.modalKeyEdit];
        },
        displayModalInstance() {
            return this.$refs[this.displayModalKey];
        },
    },
    methods: {
        onCloseClick() {
            this.$emit('on-close-click');
        },
        onSaved() {
            this.loadData();
        },
        onRemove(document) {
            this.$confirm(
                this.$t('Site.LinkedDocuments.Messages.UnlinkConfirmation')
                    .replace('{0}', document.linkedDocumentId)
                    .replace('{1}', document.mainDocumentId),
                {
                    title: this.$t('Site.LinkedDocuments.Titles.UnlinkDocument'),
                    icon: 'mdi-warning',
                    color: 'red',
                    buttonTrueText: this.$t('Site.LinkedDocuments.Titles.Unlink'),
                    buttonFalseText: this.$t('Cancel'),
                }
            ).then((res) => {
                if (res == 1) {
                    LinkedDocumentService.remove(document.id)
                        .then(() => {
                            this.loadData();
                            Utils.toast.success(this.$t('Site.LinkedDocuments.Messages.UnlinkSuccess')
                                .replace('{0}', document.linkedDocumentId)
                            );
                        })
                        .catch((error) => {
                            Utils.toast.error(this.$t('Site.LinkedDocuments.Messages.UnlinkDocumentError').replace('{0}', error.message));
                        });
                }
            });
        },
        onEdit(document) {
            this.modalInstanceEdit.edit(document);
        },
        add() {
            this.modalInstanceAdd.new(this.documentId);
        },
        loadData() {
            this.loading = true;
            LinkedDocumentService.getList(this.documentId).then((data) => {
                this.linkedDocumentList = data.map(function (dto) {
                    return new LinkedDocument(dto);
                });
                this.loading = false;
                this.$emit(
                    'on-linked-documents-updated',
                    this.linkedDocumentList.length
                );
            });
        },
        onDisplay(document) {
            this.displayModalInstance.displayLinkedDocument(document);
        },
    },
};
</script>